<template>
  <div>
    <common-table :url="url"
                  :table-columns="tableColumns"
                  :form-fields="formFields"
                  :operate="operate"
                  :permission="permission"
                  :searchs="searchs"
                  :auto-update="true"
                  ref="table">
    </common-table>

  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import message from "@/utils/message";
import request from "@/utils/axios";

export default {
  name: "DouYinProduct",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'productName',
        placeholder: '商品名称',
        type: 'input'
      }, {
        name: 'templateNum',
        placeholder: '模板',
        type: 'select',
        selectUrl: '/productTemplate/getAll',
        selectData: [],
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [{
          key: 0,
          value: '采集失败',
        }, {
          key: 1,
          value: '未采集',
        }, {
          key: 2,
          value: '采集中',
        }, {
          key: 3,
          value: '采集完成',
        }]
      }, {
        name: 'editingStatus',
        placeholder: '剪辑状态',
        type: 'select',
        selectValue: [{
          key: 0,
          value: '剪辑失败',
        }, {
          key: 1,
          value: '未剪辑',
        }, {
          key: 2,
          value: '剪辑中',
        }, {
          key: 3,
          value: '剪辑完成',
        }]
      }],
      permission: {
        add: 'douYinProduct:add',
        update: 'douYinProduct:update',
        delete: 'douYinProduct:delete',
        deleteBatch: 'douYinProduct:deleteBatch'
      },
      url: {
        get: '/douYinProduct/listByCondition',
        add: '/douYinProduct/add',
        update: '/douYinProduct/update',
        delete: '/douYinProduct/delete/',
        delete_batch: '/douYinProduct/deleteBatch',
        status: '/douYinProduct/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, /*{
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      }, */{
        field: 'liveRoomId',
        label: '平台直播间ID',
        detail: true,
        show: false,
        width: '',
      },
        {
          field: 'productName',
          label: '商品名称',
          show: true,
          width: '',
        }, {
          field: 'keyWord',
          label: '关键词',
          show: true,
        }, {
          field: 'templateNum',
          label: '模板',
          show: {
            type: 'select'
          },
          selectUrl: "/productTemplate/getAll",
        }, {
          field: 'productId',
          label: '商品ID',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'shareId',
          label: '推广ID',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'price',
          label: '商品价格',
          detail: true,
          show: false,
          width: '',
        },
        {
          field: 'commission',
          label: '佣金',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'rate',
          label: '佣金比',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'link',
          label: '商品链接',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'productShareLink',
          label: '分享链接',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'productPromotionLink',
          label: '推广链接',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'status',
          label: '状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '采集失败',
              type: 'danger'
            }, {
              key: 1,
              value: '未采集',
              type: 'warning'
            }, {
              key: 3,
              value: '采集完成',
              type: 'success'
            }, {
              key: 2,
              value: '采集中',
              type: 'warning'
            }]
          },
          detail: false,
          width: '',
        }, {
          field: 'editingStatus',
          label: '剪辑状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '剪辑失败',
              type: 'danger'
            }, {
              key: 1,
              value: '未剪辑',
              type: 'warning'
            }, {
              key: 3,
              value: '剪辑完成',
              type: 'success'
            }, {
              key: 2,
              value: '剪辑中',
              type: 'warning'
            }]
          },
          detail: false,
          width: '',
        }, {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }],
      operate: [{
        icon: 'el-icon-edit',
        type: 'text',
        text: '采集',
        exist: (row) => {
          return row.status === 1 && this.$refs.table.havePermission('douYinProduct:update')
        },
        handle: (row) => {
          if (row.status != 1) {
            message.warning("已采集，不可重复操作");
            return;
          }
          request.post({
            url: '/douYinProduct/update',
            data: {id: row.id, status: 2},
            success: (data) => {
              if (data.code == 0) {
                message.success("操作成功");
                this.$refs.table.getData();
              } else {
                message.error("操作失败");
              }
            }
          });
        }
      }, {
        icon: 'el-icon-edit',
        type: 'text',
        text: '剪辑',
        exist: (row) => {
          return row.editingStatus === 1 && this.$refs.table.havePermission('douYinProduct:update')
        },
        handle: (row) => {
          if (row.editingStatus != 1) {
            message.warning("已剪辑，不可重复操作");
            return;
          }
          request.post({
            url: '/douYinProduct/update',
            data: {id: row.id, editingStatus: 2},
            success: (data) => {
              if (data.code == 0) {
                message.success("操作成功");
                this.$refs.table.getData();
              } else {
                message.error("操作失败");
              }
            }
          });
        }
      }, {
        icon: 'el-icon-download',
        type: 'text',
        text: '压缩下载',
        exist: (row) => {
          return row.status === 3 && this.$refs.table.havePermission('douYinProduct:download')
        },
        handle: (row) => {
          request.get({
            url: '/douYinProduct/download/' + row.id,
            success: (data) => {
              if (data.code == 0) {
                message.success("操作成功");
                this.$refs.table.getData();
              } else {
                message.error("操作失败");
              }
            }
          });
        }
      }],
      formFields: {
        addTitle: '抖音商品添加',
        updateTitle: '抖音商品修改',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'liveRoomId',
          label: '平台直播间ID：',
          type: 'input',
          placeholder: '请输入平台直播间ID',
          rules: [{required: false, message: '请输入平台直播间ID', trigger: 'blur'}],
          add: true,
          update: true,
        }, {
          field: 'productName',
          label: '商品名称',
          type: 'input',
          placeholder: '商品名称',
          rules: [{message: '请输入商品名称', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'keyWord',
          label: '关键词',
          type: 'input',
          placeholder: '关键词',
          rules: [{message: '请输入关键词', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'productId',
          label: '商品ID',
          type: 'input',
          placeholder: '商品ID',
          rules: [{message: '请输入商品ID', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'shareId',
          label: '推广ID',
          type: 'input',
          placeholder: '推广ID',
          rules: [{message: '请输入推广ID', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'price',
          label: '商品价格',
          type: 'input',
          placeholder: '商品价格',
          rules: [{message: '请输入商品价格', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'commission',
          label: '佣金',
          type: 'input',
          placeholder: '佣金',
          rules: [{message: '请输入佣金', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'rate',
          label: '佣金比',
          type: 'input',
          placeholder: '佣金比',
          rules: [{message: '请输入佣金比', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'link',
          label: '商品链接',
          type: 'textarea',
          placeholder: '商品链接',
          rules: [{message: '请输入商品链接', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'productPromotionLink',
          label: '推广链接',
          type: 'textarea',
          placeholder: '分享链接',
          rules: [{message: '请输入分享链接', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'status',
          label: '状态：',
          type: 'select',
          placeholder: '请选择状态',
          rules: [{required: true, message: '请选择状态', trigger: 'blur'}],
          selectData: [{
            id: 1,
            name: '未采集'
          }, {
            id: 2,
            name: '采集中'
          }, {
            id: 3,
            name: '采集完成'
          }, {
            id: 0,
            name: '采集失败'
          }],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'editingStatus',
          label: '剪辑状态：',
          type: 'select',
          placeholder: '请选择剪辑状态',
          rules: [{required: true, message: '请选择剪辑状态', trigger: 'blur'}],
          selectData: [{
            id: 1,
            name: '未剪辑'
          }, {
            id: 2,
            name: '剪辑中'
          }, {
            id: 3,
            name: '剪辑完成'
          }, {
            id: 0,
            name: '剪辑失败'
          }],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'templateNum',
          label: '模板',
          type: 'select',
          placeholder: '请选择模板',
          rules: [{required: false, message: '请选择模板', trigger: 'blur'}],
          selectData: [],
          selectUrl: "/productTemplate/getAll",
          add: true,
          update: true,
          filterable: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
